import { ButtonSize } from '@atlas/components';
import classNames from 'classnames';
import type { FC } from 'react';

import DepositButton from 'components/DepositButton';
import { AuthStatus, useClientProfile } from 'store';
import { getMediaUrl } from 'utils/assets';
import useLayout, { type LayoutType } from 'utils/layout';
import { useTranslation } from 'utils/translations';

import BannerInput from './BannerInput';

import styles from './WelcomeBanner.module.scss';

type WelcomeBannerProps = {
  titleSignedIn: string;
  descriptionSignedIn: string;
  titleSignedOut: string;
  descriptionSignedOut: string;
  image: Record<LayoutType, string>;
};

const WelcomeBanner: FC<WelcomeBannerProps> = ({
  titleSignedIn,
  descriptionSignedIn,
  titleSignedOut,
  descriptionSignedOut,
  image,
}) => {
  const layout = useLayout();
  const [{ status }] = useClientProfile();
  const backgroundImage = getMediaUrl(image[layout], 'cms');

  const tTitleSignedIn = useTranslation(titleSignedIn);
  const tDescriptionSignedIn = useTranslation(descriptionSignedIn);
  const tTitleSignedOut = useTranslation(titleSignedOut);
  const tDescriptionSignedOut = useTranslation(descriptionSignedOut);

  const isSignedIn = status === AuthStatus.signedIn;

  const titleText = isSignedIn ? tTitleSignedIn : tTitleSignedOut;

  const descriptionText = isSignedIn
    ? tDescriptionSignedIn
    : tDescriptionSignedOut;

  const showTitle = isSignedIn
    ? Boolean(titleSignedIn)
    : Boolean(titleSignedOut);

  const showDescription = isSignedIn
    ? Boolean(descriptionSignedIn)
    : Boolean(descriptionSignedOut);

  const renderActionComponent = status !== AuthStatus.resolving;

  return (
    <div
      className={classNames(styles['welcome-banner'], styles[layout])}
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {showTitle && <h2 className={styles.title}>{titleText}</h2>}
      {showDescription && (
        <h3 className={styles.description}>{descriptionText}</h3>
      )}
      {renderActionComponent && isSignedIn && (
        <DepositButton className={styles['cta-button']} size={ButtonSize.big} />
      )}
      {renderActionComponent && !isSignedIn && <BannerInput />}
    </div>
  );
};

export default WelcomeBanner;
